var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-card",
                {
                  attrs: {
                    "border-variant": "success",
                    "header-bg-variant": "success",
                    header: "Datos de la solicitud",
                    "header-text-variant": "white",
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: _vm.colSize } },
                        [
                          _c("b-form-group", { attrs: { label: "Id" } }, [
                            _vm.solicitud?.id
                              ? _c("p", [_vm._v(_vm._s(_vm.solicitud.id))])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: _vm.colSize } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Solicitud" } },
                            [
                              _vm.solicitud?.SOLICITUD_RIZOMA
                                ?.documentoSolicitud?.documento.uri
                                ? _c(
                                    "p",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            href: _vm.solicitud.SOLICITUD_RIZOMA
                                              .documentoSolicitud.documento.uri,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("Solicitud")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: _vm.colSize } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Pefil único" } },
                            [
                              _vm.solicitud?.SOLICITUD_RIZOMA?.documentoPu
                                ?.documento.uri
                                ? _c(
                                    "p",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            href: _vm.solicitud.SOLICITUD_RIZOMA
                                              .documentoPu.documento.uri,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("Perfil Único")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.becaId
                        ? _c(
                            "b-col",
                            { attrs: { md: _vm.colSize } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Finiquito" } },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.visualizar(true)
                                            },
                                          },
                                        },
                                        [_vm._v("Finiquito")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: _vm.colSize } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "consultaSolicitudesConclusion.acciones.historicoBecasYApoyos"
                                ),
                              },
                            },
                            [
                              _c(
                                "p",
                                [
                                  _c(
                                    "b-link",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.showModalHistorico()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "consultaSolicitudesConclusion.acciones.historicoBecasYApoyos"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "b-modal",
                                  {
                                    ref: "visorFiniquitoModal",
                                    attrs: {
                                      title: "Finiquito",
                                      size: "xl",
                                      centered: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "modal-footer",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "float-right",
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.visualizar(false)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "global.process.load.close"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        _c("finiquito", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            idBeca: _vm.becaId,
                                            visible: true,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  ref: "historicoApoyoModal",
                  attrs: {
                    "header-bg-variant": "primary",
                    size: "xl",
                    title: _vm.$t(
                      "consultaSolicitudesConclusion.modal.historicoApoyos"
                    ),
                  },
                  on: {
                    hidden: function ($event) {
                      return _vm.hideModalHistorico()
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-3",
                                      attrs: { variant: "outline-danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.hideModalHistorico()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "icon-cerrar",
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("entity.action.close")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c("historico-apoyos", {
                      attrs: { cvu: _vm.cvuExbecario },
                    }),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }